import { Block, Flex, Icon, IconButton, Link, ModeSwitcher, Tabs, Typography } from '@aloft/toolkit-sui'
import { SettingsControls } from '../../../components/Settings/SettingsControls.tsx'
import { VIEW_MODES } from '../consts.ts'
import { ViewMode } from '../types.ts';
import { useSiteValueAdjuster } from '../../referenceView/utils/useSiteValueAdjuster.ts';
import { selectCompSequence, selectHasArvOption } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { selectAivArvActiveTab } from '../../../redux/features/selectors/uiSelectors.ts';
import { AivArvActiveTab } from '../../../redux/types.ts';
import { setAivArvActiveTab } from '../../../redux/features/uiSlice.ts';

export const AppraisifyAnalysisToolbar = ({ viewMode, setViewMode }: { viewMode: ViewMode; setViewMode: (viewMode: ViewMode) => void }) => {
  const dispatch = useAppDispatch();
  const compSequence = useAppSelector(selectCompSequence);
  const { adjust } = useSiteValueAdjuster();
  const hasArvOption = useAppSelector(selectHasArvOption);
  const activeTab = useAppSelector(selectAivArvActiveTab);

  const tabs: { label: string; value: AivArvActiveTab }[] = [
    { label: 'All', value: 'all' },
    { label: 'As-Is Value', value: 'aiv' },
    { label: 'After-Repair Value', value: 'arv' },
  ];

  return (
    <Flex
      className="toolbar-container"
      flexDirection="column"
      flexShrink={1}
      paddingTop="0.5rem"
      backgroundColor="surface1"
      gap="0px"
    >
      <Flex alignItems="center" gap="1.5rem" paddingX="24px" paddingY="8px" flexWrap="wrap">
        <Block marginTop="-2px">
          <ModeSwitcher
            items={Object.entries(VIEW_MODES).map(([id, label]) => ({ id, label }))}
            value={viewMode}
            variant="secondary"
            size="sm"
            onChange={(newViewMode) => setViewMode(newViewMode as ViewMode)}
          />
        </Block>
        <IconButton
          icon="chart-mixed"
          size="xs"
          variant="primary"
          ariaLabel="Adjust effective age using Power curve"
          onClick={adjust}
          disabled={compSequence.length <= 1}
          text="Power Curve Adjustment"
          textColor="textOffset"
        />
        <Flex alignItems="center">
          <Typography variant="body2" color="buttonDefault">Not sure what to do?&nbsp;</Typography>
          <Link isExternal href="https://www.loom.com/share/c7dbe08431dc4b27b93f185028ccad3f?sid=c5860b3c-aa0b-4eb3-aa32-a56a59dc102d" variant="unstyled">
            <Typography __dangerDoNotUseSx={{ textDecoration: 'underline' }} variant="body2" color="buttonDefault">Watch a demo video</Typography>
          </Link>
          <Icon icon="play-button" color="buttonDefault" __styleDoNotUse={{ marginLeft: '3px' }} />
        </Flex>
        <Block flexGrow={1} />
        <Block marginRight="1rem">
          <SettingsControls />
        </Block>
      </Flex>
      {hasArvOption && (
        <Flex paddingTop="0.5rem" width="100%">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={(tab: AivArvActiveTab) => dispatch(setAivArvActiveTab(tab))}
            variant="primary"
          />
        </Flex>
      )}
    </Flex>
  )
}
